import { render, staticRenderFns } from "./WikiTemplateCode.vue?vue&type=template&id=54e165f0"
import script from "./WikiTemplateCode.vue?vue&type=script&lang=ts"
export * from "./WikiTemplateCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports